import { SxProps } from '@mui/material'

export interface PackageSummaryStyles {
  wrapper: SxProps
  stickyWrapper: SxProps
  heading: SxProps
  showDetailsButton: SxProps
  showDetailsText: SxProps
  row: SxProps
  people: SxProps
  savings: SxProps
  breakdown: SxProps
  feeRow: SxProps
  continueButton: SxProps
  value: SxProps
  tax: SxProps
  divider: SxProps
  priceLoader: SxProps
  flightArrow: SxProps
  actualCharge: SxProps
  fanaticsCashRow: SxProps
}

export const packageSummaryStyles: PackageSummaryStyles = {
  wrapper: {
    p: { xs: 2.5, md: 3 },
    borderRadius: 4,
    border: '1px solid',
    borderColor: 'button.borderDisabled',
    boxShadow: '0px 1px 2px 0px  rgba(10, 13, 18, 0.05)',
    backgroundColor: 'background.default',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
    alignSelf: 'flex-start',
  },
  stickyWrapper: {
    mb: { xs: 17, lg: 0 },
  },
  heading: {
    typography: 'textMdSemibold',
    color: 'text.primary',
  },
  showDetailsButton: {
    ml: 1.5,
  },
  showDetailsText: {
    typography: 'textSmSemibold',
    color: 'text.hyperLink',
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    gap: 2.5,
  },
  people: {
    typography: 'textSmSemibold',
    color: 'text.primary',
  },
  savings: {
    typography: 'textSmSemibold',
    color: 'utils.green600',
  },
  value: {
    typography: 'textSmSemibold',
    color: 'text.secondary700',
    ml: 1.5,
  },
  breakdown: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5,
  },
  feeRow: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  tax: { typography: 'textSm', color: 'text.secondary700' },
  divider: { bgcolor: 'button.borderDisabled' },

  continueButton: {
    width: '100%',
    py: 1.25,
  },
  priceLoader: {
    width: 40,
    ml: 'auto',
  },
  flightArrow: {
    width: { xs: 15, md: 20 },
    display: 'inline-block',
  },
  actualCharge: {
    typography: 'textXs',
    color: 'text.secondary700',
    fontStyle: 'italic',
    textAlign: 'right',
  },
  fanaticsCashRow: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
}
